<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Becas alumnos</span>
	  		    <v-spacer></v-spacer>

	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( becas  , 'CICLOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>

	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="6" lg="5">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>

	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="becas"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.aprobadoSN="{ item }">
							      <v-chip 
							      	v-if="item.aprobadoSN == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>

							    <template v-slot:item.tipo_registro="{ item }">
							      <v-chip 
							      	v-if="item.tipo_registro == 1"
							      	small
							      	dark
							      >Becado</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >Empleado</v-chip>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>

							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_ciclo }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12">
          		<lable>Tipo de registro</lable>
          		<v-radio-group
					      v-model="tipo_registro"
					      row
					    >
					      <v-radio
					        label="Empleado"
					        :value="1"
					      ></v-radio>
					      <v-radio
					        label="Automática"
					        :value="4"
					      ></v-radio>
					    </v-radio-group>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12">
             <label>Alumno</label>
             	<v-autocomplete
	              dense
	              filled
	              clearable
	              v-model="alumno"
	              :items="alumnos"
	              label="Selecciona el alumno"
	              hide-details
	              item-text="datos_completos"
	              item-value="id_alumno"
	            >
	            </v-autocomplete>
            </v-col>

            <v-col cols="12">
             <label>Empleado</label>
             	<v-autocomplete
	              dense
	              filled
	              clearable
	              v-model="empleado"
	              :items="empleados"
	              label="Selecciona el Empleado"
	              hide-details
	              item-text="nombre_completo"
	              item-value="id_usuario"
	            >
	            </v-autocomplete>
            </v-col>


            <v-col cols="12">
          		<lable>Porcentaje beca</lable>
          		<v-radio-group
					      v-model="porcentaje_beca"
					      row
					    >
					      <v-radio
					        label="25"
					        :value="1"
					      ></v-radio>
					      <v-radio
					        label="50"
					        :value="2"
					      ></v-radio>
					      <v-radio
					        label="75"
					        :value="3"
					      ></v-radio>
					      <v-radio
					        label="100"
					        :value="4"
					      ></v-radio>
					    </v-radio-group>
            </v-col>


            <v-col cols="12">
            	<label>Cant. De becas</label>
              <v-text-field
                label="Becas disponibles"
                type="number"
                filled
                dense
                hide-details
                v-model="cantidad"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pt-0">
            	<v-switch 
            		label="¿Ciclo Abierto Si/No?"
                hide-details
            		v-model="editedItem.ciclo_abierto_sn">
            	</v-switch>
            	
            	<v-switch 
            		label="¿Activo Si/No?"
                hide-details
            		v-model="editedItem.activo_sn">
            	</v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="dark"
            small
            dark
            tile
            @click="close"
          >
          	<v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>
          
          <v-btn
            color="primary"
            dark
            small
            tile
            @click="save"
          >
          	<v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  
  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],
    
  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      dialogRelacionar:false,
      ciclosActivos:[],

      
      editedIndex: -1,

      editedItem: {
        id_ciclo:0,
				ciclo:'',
				fecha_inicio_ciclo:null,
				fecha_fin_ciclo:null,
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
				ciclo_abierto_sn:0,
				id_ciclo_relacionado:0
      },

      defaultItem: {
        id_ciclo:0,
				ciclo:'',
				fecha_inicio_ciclo:null,
				fecha_fin_ciclo:null,
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
				ciclo_abierto_sn:0,
				id_ciclo_relacionado:0
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      becas: [],
      alumnos:[],
      alumno: null,
      empleados:[],
      empleado:null,
      headers: [
        { text: 'ID'            , value: 'id'             },
        { text: 'Alumno'        , value: 'alumno'         },
        { text: 'Beca'          , value: 'beca'           },
        { text: 'Aprobada'      , value: 'aprobadoSN'     },
        { text: 'Comentarios'   , value: 'comentarios'    },
        { text: 'Tipo registro' , value: 'tipo_registro'  },
        { text: 'Cantidad'      , value: 'cantidad'       },
        { text: 'Restan'        , value: 'restan'         },
        { text: 'Fecha alta'    , value: 'fecha_alta'     },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      tipo_registro: null,
      porcentaje_beca: null,
      cantidad:null,
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ciclo' : 'Editar ciclo'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    async created () {
      await this.initialize()
      await this.getAlumnos()
      await this.getEmpleados()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.becas = []
        return this.$http.get('becas.list').then(response=>{
        	this.becas = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getAlumnos () {
      	this.cargar = true
        this.alumnos = []
        return this.$http.get('descuentos.alumnos').then(response=>{
        	this.alumnos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getEmpleados () {
      	this.cargar = true
        this.empleados = []
        return this.$http.get('usuarios.activos').then(response=>{
        	this.empleados = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.becas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.becas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem['id_usuario'] = this.getdatosUsuario.iderp
        this.$http.put('becas.eliminar/' + this.editedItem.id_ciclo, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	if(this.editedItem.ciclo == ''){
      		this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
      	this.editedItem['id_usuario'] = this.getdatosUsuario.iderp
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('becas.update/' + this.editedItem.id_ciclo, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('becas.add', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error.response.data.message )
        	}).finally( () => { this.cargar = false })
        }
        this.close()
      },

    },
  }
</script>


